import { useWindowSize } from 'hooks';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import { useStore } from 'store';
import { fetchFAQs } from 'store/actions/faqs';
import NextIcon from 'assets/img/next.svg'
import styles from './style.module.scss';

export const QuestionHome = ({ home }) => {
    const [, { isMobile }] = useWindowSize();
    const [listOfFAQs, dispatch] = useStore(({ faqs }) => faqs.listOfFAQs);
    const ListOfFAQsFull = listOfFAQs.results.list;
    const { params = {} } = listOfFAQs;
    const { totalPages } = listOfFAQs;
    // const listOfQuestions = ListOfFAQsFull.slice(0, isMobile ? 2 : 5);
    
    useEffect(() => {
        if (totalPages >= params.page) {
            dispatch(fetchFAQs({ incrementalList: false }));
        }
    }, [params.page]);

    // eslint-disable-next-line no-unused-vars
    const [respuestasVisibles, setRespuestasVisibles] = useState([]);

    // eslint-disable-next-line no-unused-vars
    const toggleRespuesta = (index) => {
        setRespuestasVisibles((prevRespuestasVisibles) => {
            const updatedRespuestasVisibles = [...prevRespuestasVisibles];
            updatedRespuestasVisibles[index] = !updatedRespuestasVisibles[index];
            return updatedRespuestasVisibles;
        });
    };

    
    const [activeAccordionIndex, setActiveAccordionIndex] = useState(null);
    const [activeAccordionIndexInt, setActiveAccordionIndexInt] = useState(null);

    const handleAccordionToggle = (index) => {
        setActiveAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    
    const handleAccordionToggleInt = (index) => {
        setActiveAccordionIndexInt((prevIndex) => (prevIndex === index ? null : index));
    };

    const [newFAQS, setNewFAQS] = useState(false)
    useEffect(()=>{
      if(ListOfFAQsFull.length >= 1){
        const cat0 = ListOfFAQsFull.map(categoria => categoria.category)
        const cat1  = cat0.filter((valor, indice) => cat0.indexOf(valor) === indice )
        const categoria = cat1.map(catTotal => {
          const FAQSTotal =  {
            'category': catTotal,
            'faqs': ListOfFAQsFull.filter(faqs => faqs.category === catTotal)
          }
          return FAQSTotal
        })
        setNewFAQS(categoria)
      }
    },[ListOfFAQsFull])

    useEffect(()=>{
        if(newFAQS){
            // console.log('newFAQS Home: ',newFAQS)
        }
      },[newFAQS])

    return (
        <>
        {
            isMobile ? (
                <div className={styles['link-container']}>
                    <Link 
                        className={styles['link-mobile']}
                        to = "/faqs"
                    >
                        Preguntas frecuentes <img src ={NextIcon} alt='next' className={styles['next-icon']}/>
                    </Link>
                </div>
            ) : (
                <section className={styles.QuestionHome}>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <p className={styles.title}>Preguntas Frecuentes</p>
                            </div>
                        </div>
                        
                        <Accordion>
                            {newFAQS && newFAQS.map((questionList, ind) => (
                                <Card key={ind}>
                                    <Accordion.Toggle
                                        as={Card.Header}
                                        className={`${activeAccordionIndex === ind ? styles.cardheadertextred : styles.cardheader}`}
                                        eventKey={ind.toString()}
                                        onClick={() => handleAccordionToggle(ind)}
                                    >
                                        <span>{questionList.category}</span>
                                        <i
                                            className={`fa ${activeAccordionIndex === ind ? 'fa-angle-up' : 'fa-angle-down'} ${styles.icon}`}
                                        />
                                    </Accordion.Toggle>

                                    <Accordion.Collapse eventKey={ind.toString()}>
                                        <Card.Body style={{ backgroundColor: '#CCC' }}>
                                            <Accordion>
                                                {questionList?.faqs.map((question, index) => (
                                                    <Card key={`${ind}-${index}`}>
                                                        <Accordion.Toggle
                                                            as={Card.Header}
                                                            className={`${String(activeAccordionIndexInt) === `${ind}-${index}` ? styles.cardheadertextredInt : styles.cardheaderInt}`}
                                                            eventKey={`${ind}-${index}`}
                                                            onClick={() => handleAccordionToggleInt(`${ind}-${index}`)}
                                                        >
                                                            <span>{question.question}</span>
                                                            <i
                                                                className={`fa ${String(activeAccordionIndexInt) === `${ind}-${index}` ? 'fa-angle-up' : 'fa-angle-down'} ${styles.icon}`}
                                                            />
                                                        </Accordion.Toggle>
                                                        <Accordion.Collapse eventKey={`${ind}-${index}`}>
                                                            <Card.Body style={{ backgroundColor: '#e6e6e6' }}>
                                                                <div className={styles?.answer_content} dangerouslySetInnerHTML={{ __html: question.answer }} />
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                ))}
                                            </Accordion>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            ))}
                        </Accordion>


                        <div />
                        <br />
                        <div className="row d-flex justify-content-center mx-sm-2">
                            <div className="col-xs-12 col-lg-4 align-self-center ">
                                <Link className="link-button" to="/faqs">
                                    <Button size="lg" block variant="primary">
                                        Ver más preguntas
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>

                </section>
            )
        }
        </>
    );
};
